<template>
  <!-- Use the new refactored RelatedPage component -->
  <RelatedPage
    :member-line-id="memberLineId"
    :member-name="memberName"
    :group-id="groupId"
    :update-group-story-ship="updateGroupStoryShip"
    :update-finished-demo="updateFinishedDemo"
    @change-judge="$emit('change-judge', $event)"
  />
</template>

<script>
import RelatedPage from './RelatedPage.vue';

/**
 * Legacy Relateds index component - now delegates to refactored RelatedPage
 * This maintains backward compatibility while using the new SOLID architecture
 */
export default {
  name: 'RelatedIndex',
  
  components: {
    RelatedPage
  },
  
  props: [
    'memberLineId',
    'memberName', 
    'groupId',
    'updateGroupStoryShip',
    'updateFinishedDemo'
  ],
  
  emits: ['change-judge']
};
</script>
<style lang="scss" src="./style.scss"></style>
